
import cityJson from './city.json'
import onlycityJson from './onlyCity.json'
// code转汉字大对象
const CodeToText = {}

cityJson.forEach(provinceItem => {
    // 省
    CodeToText[provinceItem.value] = provinceItem.label

    if (provinceItem.children && provinceItem.children.length > 0) {
        // 市
        provinceItem.children.forEach(cityItem => {
            CodeToText[cityItem.value] = cityItem.label

            // 区
            if (cityItem.children && cityItem.children.length > 0) {
                // 区
                cityItem.children.forEach(areaItem => {
                    CodeToText[areaItem.value] = areaItem.label
                })
            }
        })
    }
})
export { cityJson,onlycityJson, CodeToText }
